import { eventChannel, END } from 'redux-saga';
import {
  call, select, put, take,
} from 'redux-saga/effects';
import {
  initCCLICommunication,
  getCCLIFusionLandlineNumber,
  getCCLILineProducts,
  getCCLIMainFusionNumber,
  getCCLILineSVATerminal,
  getCCLINoFusionLandlineNumber,
} from '@bit/gerenciatd.utils.ccli-iframe';
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import * as fusionSagas from './fusion';
import { actions as fusionActions } from '../reducers/fusion';
import { tratarParqueCCLI } from '../utils/productUtils';

const contextStore = (state) => state.context.data;

/**
 * Realiza la comunicación con CCLI para obtener tanto el parque de legado
 * como la obtención del terminal si lo tiene
 * @param {boolean} end flag para saber cuando terminar el bucle de comunicación
 * @param {object} context contexto de la app
 * @return {Object}  el canal de comunicación
 */
export function iframeCCLIListener(end = false, context) {
  return eventChannel((emitter) => {
    const iv = 0;
    const sonda = new Sonda({
      processName: 'iframeCCLISubscription',
      context,
      filePath: 'sagas/Legado',
    });
    if (!end) {
      try {
        let responseInit = null;
        let result = null;
        const svaCode = 'B33';
        initCCLICommunication(
          'iframeCCLI',
          (response1) => {
            responseInit = response1;
            responseInit = response1;
            const lineaFusion = getCCLIFusionLandlineNumber(response1);
            const lineaNoFusion = getCCLINoFusionLandlineNumber(response1);
            let lineaContratada = '';
            if (lineaFusion !== '') {
              lineaContratada = lineaFusion;
            } else if (lineaNoFusion !== '') {
              lineaContratada = lineaNoFusion;
            }
            if (lineaContratada) {
              getCCLILineProducts(
                'iframeCCLI',
                lineaContratada,
                (response2) => {
                  result = tratarParqueCCLI(response2);
                  if (result) {
                    const mainFusionNumber = getCCLIMainFusionNumber(
                      responseInit
                    );
                    let mainFusionLine = null;
                    if (mainFusionNumber && mainFusionNumber.msisdn) {
                      mainFusionLine = mainFusionNumber.msisdn;
                      getCCLILineProducts(
                        'iframeCCLI',
                        mainFusionLine,
                        (response3) => {
                          const result2 = getCCLILineSVATerminal(
                            response3,
                            svaCode
                          );
                          let gotTerminal = false;
                          if (result2.saTerminal !== undefined) {
                            gotTerminal = true;
                          }
                          emitter({ result, gotTerminal });
                        },
                        context,
                        true
                      );
                    } else {
                      emitter({ result, gotTerminal: false });
                    }
                  } else {
                    emitter({ incompatible: true });
                  }
                },
                context,
                true
              );
            } else {
              emitter({ incompatible: true });
            }
          },
          context
        );
      } catch (error) {
        sonda.errorMessage({ error });
        emitter({ incompatible: true });
      }
    } else {
      clearInterval(iv);
      emitter(END);
    }
    // The subscriber must return an unsubscribe function, but it will never happen
    return () => {
      if (iv !== null) {
        clearInterval(iv);
      }
    };
  });
}

/**
 * Creación llamada asincrona para manejar la llamada del api
 * de comunicaciones de ccli de obtención de parque y terminal
 * @return {undefined}
 */
export function* iframeCCLISubscription() {
  const context = yield select(contextStore);
  const sonda = new Sonda({
    processName: 'iframeCCLISubscription',
    context,
    filePath: 'sagas/Legado',
  });
  const sondaFinding = new Sonda({
    processName: 'INVESTIGACION_LEGADO',
    context,
    filePath: '-SAGA:Fusion-legado',
  });
  try {
    const chan = yield call(iframeCCLIListener, false, context);
    while (true) {
      const info = yield take(chan);
      console.log(info);
      if (info.incompatible) {
        const parqueIncompatible = {
          event: 'cms-page',
          'event-type': 'parque-login',
          'prod-cont-code': 'no-recuperado',
        };
        if (window.nookInfoExchange && window.nookInfoExchange.sendMessage) {
          window.nookInfoExchange.sendMessage('Metrics', parqueIncompatible);
        }
        sondaFinding.warningMessage({
          info: `CASO-PARTICULAR: productInfo:${JSON.stringify({
            info,
          })}`,
        });
        yield call(fusionSagas.manageMyProductsData, {
          incompatible: true,
        });
      } else {
        const aliasType = 'ci';
        yield put(fusionActions.setClientAlreadyDevice(info.gotTerminal));
        yield call(fusionSagas.manageMyProductsData, {
          productInfo: info.result,
          aliasType,
        });
      }
      yield call(iframeCCLIListener, true, context);
    }
  } catch (error) {
    sonda.errorMessage({ error });
  }
}
